import { StorageService } from './storage.service';
import { ROUTE_LOGIN } from './../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { IAuthentication } from '../models/iauthentication.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
}
)
export class LoginService {

    constructor(
        private apiService: ApiService,
        private storageService: StorageService,
        private http: HttpClient
    ) {

    }


    validarCaptcha(_object: any) {
        return this.http.post(environment.serviceUrlLogin + "usuario/auth-captcha", _object, { observe: "response" })
    }



    validarToken() {
        const TOKEN = this.storageService.getData('token') || '';
        if (TOKEN) {
            return true
        } else {
            return false;
        }

    }

    loginUser(request: any): Observable<any> {
        this.apiService.setUrlPathLogin(ROUTE_LOGIN.login_url2);
        return this.apiService.executePostJson(request).pipe(tap((resp: HttpResponse<null>) => {
            console.log(resp);
            if (resp.status === 200) {
                let authentication: IAuthentication = resp.body;
                const authenticationData: IAuthentication = {
                    coduser: authentication.coduser,
                    nombres: authentication.nombres,
                    correo: authentication.correo,
                    ruc: authentication.ruc,
                    empresa: authentication.empresa,
                    codsuc: authentication.codsuc,
                    token: authentication.token,
                    sucursales: authentication.sucursales
                }
                this.storageService.setData('token', authentication.token);
                this.storageService.setData('authData', JSON.stringify(authenticationData))
                StorageService.setAll(JSON.stringify(resp.body))

            }
        }, (error) => {
            console.log('error logueados');
            console.log(error);
        })

        )
    }
    generaClave(ruc:string,coduser:string){
      const obj={
        ruc:ruc,
        coduser:coduser
      }
      this.apiService.setUrlPathApi('usuario/generar-clave');
      return this.apiService.executePostJson(obj).pipe();
    }

    renovarClave(data:any){
        this.apiService.setUrlPathLogin('usuario/renovar-clave');
        return this.apiService.executePutJson(data).pipe();
    }

}